import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { LIVE_APPS } from './Navbar.jsx';

export default function Network() {
  return (
    <section className="border-t border-line/70 px-4 py-14 sm:px-5 md:py-28">
      <div className="mx-auto max-w-page">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="max-w-xl"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber">
            One account, one network
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-white md:text-4xl">
            Sign in once. It works on every app I build here.
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/55">
            Every subdomain shares the same account and the same database — sign in on one,
            and you're already signed in on the rest.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-4 sm:grid-cols-3">
          {LIVE_APPS.map((app, i) => (
            <motion.a
              key={app.id}
              href={app.href}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              className="group flex flex-col items-start rounded-xl border border-line bg-panel/60 p-5 text-left transition hover:-translate-y-1 hover:border-violet/40 hover:bg-panel"
            >
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              <p className="mt-3 flex items-center gap-1.5 font-display text-base font-semibold text-white">
                {app.name}
                <ExternalLink size={13} className="text-white/30 transition group-hover:text-white/50" />
              </p>
              <p className="mt-3 text-xs leading-relaxed text-white/45">{app.blurb}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
